import React from 'react';
import { Button } from '@/shared/ui/button';

interface BugReportSuccessProps {
  onReset: () => void;
}

const BugReportSuccess: React.FC<BugReportSuccessProps> = ({ onReset }) => {
  return (
    <div className="flex flex-col items-center text-center py-8 space-y-4">
      <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-7 h-7 text-green-600" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z" />
        </svg>
      </div>
      <h2 className="text-lg font-semibold text-gray-900">Report Submitted</h2>
      <p className="text-sm text-gray-500 max-w-sm">
        Thank you for letting us know. We'll look into it and get back to you if needed.
      </p>
      <Button variant="outline" onClick={onReset}>
        Submit Another Report
      </Button>
    </div>
  );
};

export { BugReportSuccess };
